const NoteMetaData = Object.freeze({
  ROUTES: Object.freeze({
    edit: "noteedit",
    list: "notes",
  }),
  ENTITY_SET: "Notes",
});

export default NoteMetaData;
